import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@envs/environment';
import { MailWelcome } from './mailWelcome';

@Injectable({
  providedIn: 'root',
})
export class SendMailService {
  private readonly http = inject(HttpClient);
  api = `${environment.api}/api/v1/send-emails`;

  SendMailWelcome(info: MailWelcome) {
    const endpoint = `${this.api}/send-email-welcome`;
    return this.http.post(endpoint, info);
  }

  SendMailNewCustomer(info: MailWelcome) {
    const endpoint = `${this.api}/send-email-new-customer`;
    return this.http.post(endpoint, info);
  }

  SendMailInvitation(info: any) {
    let information = info;
    const endpoint =
      environment.api +
      '/api' +
      '/v1/send-email-invitation/send-email-invitation-myservy';
    return this.http.post(endpoint, information);
  }
  SendMailGeneral(info: any) {
    const endpoint = `${this.api}/send-email-general`;
    return this.http.post(endpoint, info);
  }
}
